import { numbersFilter } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelsOverviewBarChart/ChannelsOverviewBarChartContainerFormat";
import { formatPercent } from "../../../utils/numberFormatters";
import type { ScatterPlotDataItem } from "../useKeywordGroupScatterPlotData";

export const axisConfig = {
    xAxis: {
        formatter: numbersFilter,
    },
    yAxis: {
        formatter: (value) => formatPercent(value),
    },
} as const;

export const getAverageValues = (
    data: ScatterPlotDataItem[],
): { totalVolumeAverage: number; volumeChangeAverage: number } => {
    if (data.length === 0) {
        return {
            totalVolumeAverage: 0,
            volumeChangeAverage: 0,
        };
    }

    const totalVolume = data.reduce((acc, item) => acc + item.totalVolume, 0);
    const volumeChange = data.reduce((acc, item) => acc + item.volumeChange, 0);

    return {
        totalVolumeAverage: totalVolume / data.length,
        volumeChangeAverage: volumeChange / data.length,
    };
};
